import { fetchData } from "../../../utils/utils";
import { RESOURCES_URL, LOUNGE_CODE } from "../../../context/constants";
import { useQuery } from "@tanstack/react-query";

export const usePrograms = () => {
  const {
    data: programs,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["get_programs"],
    queryFn: () =>
      fetchData(
        {
          sEvent: "GETPROGRAMS",
          sSearchCriteria: "",
          loungeCode: LOUNGE_CODE
        },
        `${RESOURCES_URL}GetPrograms`,
        "post"
      ),
    staleTime: 1000 * 60 * 60 * 24, // once a day,
    placeholderData: [{ value: "", label: "Select" }],
    select: (programs) =>
      programs.map((program) => ({
        value: program.ID,
        label: `${program.Name}`,
      })),
  });

  return { programs, isLoading, isError };
};